import { axios } from '@/utils/request'
const api = {
  getList: '/merchant.php/Brand/getList',
  edit: '/merchant.php/Brand/edit',
  condition: '/merchant.php/Brand/deleteCondition',
  delete: '/merchant.php/Brand/delete'
}
export function getBrandList(parameter) {
  return axios({
    url: api.getList,
    method: 'get',
    params: parameter
  })
}
export function brandUpdate(data) {
  return axios({
    url: api.edit,
    method: 'post',
    data: data
  })
}
export function brandCondition(data) {
  return axios({
    url: api.condition,
    method: 'post',
    data: data
  })
}
export function brandDelete(data) {
  return axios({
    url: api.delete,
    method: 'post',
    data: data
  })
}
